const MuiAccordionDetails = {
  root: {
    display: 'block',
    padding: '0px 16px 16px'
  }
};

export default MuiAccordionDetails;
